"use strict";var e=require("@apollo/client"),t=require("./CategoryModel-cjs-D7VALxvO.js"),o=e.gql`
  ${t.C}
  query GetProductRecommendations(
    $getProductRecommendationsInput: GetProductRecommendationsInput!
  ) {
    getProductRecommendations(
      getProductRecommendationsInput: $getProductRecommendationsInput
    ) {
      ...CatalogProductModel
    }
  }
`;exports.g=o;